module.exports = __webpack_public_path__ + "static/assets/25a249aa7aec3b2269732cf351db3ca8.svg";